import React from 'react'
import ReactDOM from 'react-dom/client'
import { installEnvironmentTitlePrefix } from '@mts/shared/browserTitle'
import App from './App.jsx'
import './index.css'

installEnvironmentTitlePrefix({ nodeEnv: import.meta.env.VITE_NODE_ENV })

const bootstrapElement = document.getElementById('mts-public-bootstrap');
const bootstrap = bootstrapElement ? JSON.parse(bootstrapElement.textContent) : null;
const app = <React.StrictMode><App bootstrap={bootstrap} /></React.StrictMode>;
const root = document.getElementById('root');
if (bootstrap) ReactDOM.hydrateRoot(root, app);
else ReactDOM.createRoot(root).render(app);
